export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
